import { useRef } from "react";
import { Html } from "@react-three/drei";
import videoIcon from "../../static/images/video.png";

function VideoSpot({
	videoSpot,
	selectObject,
	isPreviewComponent,
	setIsInfoVideoSpotOpen,
	setInfoVideoSpotDetails,
}) {
	const mesh = useRef(null);
	const onClickHandler = () => {
		if (!isPreviewComponent) {
			setIsInfoVideoSpotOpen(true);
			setInfoVideoSpotDetails({ url: videoSpot.url, name: videoSpot.name });
		} else {
			selectObject(videoSpot, mesh.current);
		}
	};
	console.log("video", videoSpot);
	return (
		<mesh ref={mesh} position={videoSpot.position}>
			<Html center zIndexRange={[100, 10]}>
				<img
					className="hotspot"
					src={videoIcon}
					alt="info spot"
					width="35px"
					height="35px"
					onClick={(e) => {
						onClickHandler();
					}}
				/>
			</Html>
		</mesh>
	);
}
export default VideoSpot;
